
import React, { useEffect, useState } from "react";
import "../../styles/category.css";
import "../../styles/cartpop.css";
import Loader from "../loader/loader";
import { ProductApi } from "../../api/product.api";
import { PRODUCT } from "../../utils/constants";
import ProductListDisplay from "./ProductListDisplay";
import FooterBar from "../footrt/FooterBar";

function ServicePage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      window.scrollTo(0, 0);
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  async function fetchProducts() {
    setLoading(true);
    try {
      const productListResponse = await ProductApi.filterProducts({
        productType: PRODUCT.TYPE.SERVICE,
      });
      setProducts(productListResponse.products);
    } catch (error) {
      console.log("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }

  // Load cart from localStorage on component mount
  useEffect(() => {
    fetchProducts();
  }, []);


  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
          <> 
            <ProductListDisplay
              products={products}
              displayName={'Service'}
              isLoading={loading}
              isRepairPage={true}
            />
          </>
      )}
      <FooterBar />
    </>
  );
}

export default ServicePage;